import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { LoginPage } from '../../pages/LoginPage/LoginPage'
import { App } from '../../pages/Index/Index'
import { PrivateRoute } from '../PrivateRoute'

export const MainRouting = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route>
        <Route path="/*" element={
            <PrivateRoute><App /></PrivateRoute>
          }
        />
        <Route path="/:id" element={<PrivateRoute><App /></PrivateRoute>} />
      </Route>

      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  )
}
